import { render, staticRenderFns } from "./MainLang.vue?vue&type=template&id=4e7d4c58&"
import script from "./MainLang.vue?vue&type=script&lang=js&"
export * from "./MainLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports